import { render, staticRenderFns } from "./schedule.component.vue?vue&type=template&id=74277d3b&scoped=true"
import script from "./schedule.component.vue?vue&type=script&lang=ts"
export * from "./schedule.component.vue?vue&type=script&lang=ts"
import style0 from "./schedule.component.vue?vue&type=style&index=0&id=74277d3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74277d3b",
  null
  
)

export default component.exports